export const OrderPartVariantDivEnum = {
    YELLOW: 'YELLOW',
    BLUE: 'BLUE'
};